import React, { FC } from 'react';
import styled from 'styled-components';

import arrowDown from '../../image/arrow-down.svg';

const TextDown = styled.div`
  position: absolute;
  left: 0;
  right 0;
  top: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    margin-right: 10px;
    width: 20px !important;
    height: 20px !important;
  }
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: rgba(0, 0, 0, 0.6);
  
  @media (max-width: 992px) {
    
      font-size: 14px;
      line-height: 12px;
    
  }
  @media (max-width: 440px) {
    
      font-size: 10px;
      line-height: 12px;
    
    img {
      width: 10px !important;
      height: 10px !important;
    }
  }
  @media (max-height: 1300px){
    top: 85%;
  }
  @media (max-height: 660px){
    top: 80%;
  } 
  @media (max-height: 420px){
    top: 70%;
  }
`;

interface ScrollTextProps {
  children: string;
}

export const ScrollText: FC<ScrollTextProps> = ({ children }) => {
  return (
    <>
      <TextDown>
        <img src={arrowDown} alt="" />
        <>{children}</>
      </TextDown>
    </>
  );
};
